export const initCaseStudyCursorTracker = () => {
  // Select relevant DOM elements
  const pointer = document.getElementById('pointer');
  const pointerHolder = document.getElementById('pointer-holder');
  const pointerBgImg = pointer.querySelector('#pointer-bg-img img');
  let lastDataImg = '';

  // Function to check for image source
  const checkImageSource = () => {
    pointerHolder.style.opacity = lastDataImg ? '1' : '0';
  };

  // Function to handle mouse movement and update cursor position
  const respond = (e) => {
    const { offsetWidth: pointerWidth, offsetHeight: pointerHeight } = pointer;
    const { clientX: cursorX, clientY: cursorY } = e;

    // Calculate new cursor position and update the pointer's transform
    const newX = cursorX - pointerWidth;
    const newY = cursorY - pointerHeight;
    pointer.style.transform = `translate(${newX}px, ${newY}px)`;

    // Check for image source during mouse movement
    checkImageSource();

    // Check if the cursor is currently over a ".cs-link" element
    const hoveredLink = document.querySelector('.cs-link:hover');
    if (hoveredLink) {
      const dataImg = hoveredLink.getAttribute('data-img');
      // Update the pointer background image if there's a new data-img value
      if (dataImg && dataImg !== lastDataImg) {
        // Load image
        pointerBgImg.src = dataImg;
        lastDataImg = dataImg;
        checkImageSource(); // Check for image source after updating
      }
    }
  };

  // Function to handle mouse entering a link
  const handleLinkMouseEnter = (link, csLinks) => {
    const dataImg = link.getAttribute('data-img');

    // Update the pointer background image if there's a new data-img value
    if (dataImg && dataImg !== lastDataImg) {
      // Load image
      pointerBgImg.src = dataImg;
      lastDataImg = dataImg;
      checkImageSource(); // Check for image source after updating
    }

    // Adjust opacity for other links
    csLinks.forEach((otherLink) => {
      if (otherLink !== link) {
        otherLink.style.transition = 'opacity 0.3s';
        otherLink.style.opacity = '0.25';
      }
    });
  };

  // Function to handle mouse leaving a link
  const handleLinkMouseLeave = (csLinks) => {
    // Restore opacity for all links
    csLinks.forEach((link) => {
      link.style.transition = 'opacity 0.3s';
      link.style.opacity = '1';
    });
  };

  // Function to handle mouse leaving the section
  const handleSectionMouseLeave = (csLinks) => {
    // Reset pointer background image and handle link mouse leave
    pointerBgImg.src = '';
    lastDataImg = '';
    handleLinkMouseLeave(csLinks);
    // Check for image source after resetting
    checkImageSource();
  };

  // Function to check if cursor tracker should be active
  const checkCursorTracker = () => {
    // Check if the window width is above a certain breakpoint
    const isAboveBreakpoint = window.innerWidth > 980;

    // Return if not above the breakpoint
    if (!isAboveBreakpoint) {
      return;
    }

    // Select the case studies section
    const caseStudiesSection = document.querySelector('.cs-link-wrapper');

    // Return if the section is not present
    if (!caseStudiesSection) {
      return;
    }

    // Select all case study links
    const csLinks = document.querySelectorAll('.cs-link');

    // Return if there are no links
    if (csLinks.length === 0) {
      return;
    }

    // Attach event listeners for mouse enter and leave on each link
    csLinks.forEach((link) => {
      link.addEventListener('mouseenter', () =>
        handleLinkMouseEnter(link, csLinks),
      );
      link.addEventListener('mouseleave', () => handleLinkMouseLeave(csLinks));
    });

    // Attach scroll event to handle section mouse leave
    window.addEventListener('scroll', () => {
      pointerHolder.style.position = 'fixed';
      clearTimeout(window.isScrolling);
      window.isScrolling = setTimeout(
        () => handleSectionMouseLeave(csLinks),
        66,
      );
    });

    // Attach mouse move event to respond to cursor movement
    window.addEventListener('mousemove', respond);

    // Check for image source when the page loads
    checkImageSource();
  };

  // Attach resize event to check cursor tracker on window resize
  window.addEventListener('resize', checkCursorTracker);

  // Initial check when the page loads
  checkCursorTracker();
};
